import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Clearfix } from 'react-bootstrap';

import FoodSelect from '../common/FoodSelect';
import GroupSelect from '../common/GroupSelect';
import MultiFoodReportSelector from './MultiFoodReportSelector';

/**
 * Concerns of this component:
 *   control values in the forms (child components)
 *   to generate and pass query when submit
**/
class MultiFoodQueryBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      foods: this.props.selectedFoods ? this.props.selectedFoods : [],
      group: this.props.selectedGroup || 'all',
      report: this.props.selectedReport || 'nip',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setFoods = this.setFoods.bind(this);
    this.setGroup = this.setGroup.bind(this);
    this.setReport = this.setReport.bind(this);
  }

  // to update forms when navigated via history.
  componentWillReceiveProps(nextProps) {
    if(this.props !== nextProps) {
      this.setState({
        foods: nextProps.selectedFoods ? nextProps.selectedFoods : [],
        group: nextProps.selectedGroup || 'all',
        report: nextProps.selectedReport || 'nip',
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    // pass query to MultiNutrientSearch
    this.props.handleSubmit({
      // delete empty elements and create a string
      foods: this.state.foods,
      group: this.state.group === 'all' ? '' : this.state.group,
      report: this.state.report === 'nip' ? '' : this.state.report,
    });
  }

  setFoods(newFoods) {
    this.setState({foods: newFoods});
  }

  setGroup(newGroup) {
    this.setState({group: newGroup});
  }

  setReport(newReport) {
    this.setState({report: newReport});
  }

  render() {
    const { foods, groups } = this.props;

    // apply group filtering
    let options = foods;
    if (this.state.group !== 'all') {
      options = foods.filter(food => food.group_code === this.state.group)
        // current selection needs to be in options
        .concat(this.state.foods);
    }

    // workaround to limit selections up to 3.
    // 'selected' does not work when there is no change to props.
    // Typeahead does not have options to limit selection.
    let emptyLabel = '';
    if (this.state.foods.length >= 3) {
      options = this.state.foods;
      emptyLabel = 'Up to 3 foods can be selected.';
    }

    return (
      <div className="MultiFoodQueryBuilder">
        <p>
          Compare up to 3 foods on a per serve or per 100 g basis.
        </p>

        <form onSubmit={this.handleSubmit}>
          <Col sm={12} md={6}>
            <FoodSelect
              options={options}
              selected={this.state.foods}
              multiple
              label='Select foods'
              placeholder='Type to filter selection; e.g. apple or A1014'
              emptyLabel={emptyLabel}
              setFoods={this.setFoods}/>
          </Col>
          <Col sm={12} md={6}>
            <GroupSelect
              groups={groups}
              selected={this.state.group}
              setGroup={this.setGroup}
              label='filter options by food group(s)'/>

            <MultiFoodReportSelector
              selected={this.state.report}
              setReport={this.setReport}
            />
          </Col>
          <Col sm={12} className="searchButton">
            <Button type="submit" bsStyle="primary">GO</Button>
          </Col>
          <Clearfix />
        </form>

      </div>
    );
  }
}

MultiFoodQueryBuilder.propTypes = {
  foods: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  selectedFoods: PropTypes.array,
  selectedGroup: PropTypes.string,
  selectedReport: PropTypes.string,
  handleSubmit: PropTypes.func,
};

export default MultiFoodQueryBuilder;



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodQueryBuilder.js